import { Button, Checkbox, InlineError, Input } from 'avo-ui'
import TabToggle from 'components/commons/tab-toogle'
import IcChevronRight from 'components/commons/menu/ic-chevron-right.svg'

export const UserRoleCreate = ({
    activeTab,
    setActiveTabHandler,
    getPermissions,
    userRoleDetail,
    onChangeForm,
    isSelectAll,
    errorForm,
    isLoadingDetail,
    isCreating,
    isUpdating,
    onSubmit,
}) => {
    return (
        <div className={'flex flex-col gap-y-5 px-9 py-4'}>
            <div className={'flex flex-col space-y-3 w-1/2'}>
                <div className={'font-semibold text-blue-90 required'}>User Role Name</div>
                <Input
                    className={'flex-1'}
                    name={'name'}
                    placeholder={'Masukkan nama role'}
                    value={userRoleDetail?.name}
                    onChange={onChangeForm}
                />
                <InlineError className='mt-2' message={errorForm?.name} />
            </div>
            <TabToggle
                isLoading={isLoadingDetail}
                title={'Access'}
                content={
                    <div className={'flex space-x-4'}>
                        <div className={'w-1/4 border-r border-neutral-20 space-y-3 pr-4'}>
                            {userRoleDetail?.access?.map((item, index) => (
                                <div
                                    key={index}
                                    onClick={() => setActiveTabHandler(item?.name)}
                                    className={`flex items-center justify-between px-3 py-2 text-primary-100 cursor-pointer ${activeTab === item?.name ? 'font-bold bg-[#F2F7FF]' : 'font-semibold pl-7'}`}
                                >
                                    <div className={'flex items-center space-x-2.5'}>
                                        {activeTab === item?.name && (
                                            <img src={IcChevronRight} alt={'IcChevronRight'} />
                                        )}{' '}
                                        <p>{item?.name}</p>
                                    </div>
                                    <p>({item?.permission_count})</p>
                                </div>
                            ))}
                        </div>
                        <div className={'flex-1'}>
                            <div className={'grid grid-cols-3 gap-3'}>
                                <Checkbox
                                    className={
                                        'border border-neutral-20 py-2 px-3 rounded-lg text-primary-100 hover:bg-blue-5 hover:border-primary-100 cursor-pointer'
                                    }
                                    label={'Select All'}
                                    name={'Select All'}
                                    checked={isSelectAll()}
                                    value={isSelectAll()}
                                    onChange={onChangeForm}
                                />
                                {getPermissions(activeTab)?.map((item, index) => (
                                    <div key={`${item?.name}-${index}`}>
                                        <Checkbox
                                            key={index}
                                            className={
                                                'border border-neutral-20 py-2 px-3 rounded-lg text-primary-100 hover:bg-blue-5 hover:border-primary-100 cursor-pointer'
                                            }
                                            label={item?.name}
                                            name={item?.name}
                                            checked={item?.is_allowed}
                                            value={item?.is_allowed}
                                            onChange={onChangeForm}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                }
            />
            <div className={'flex justify-center py-3'}>
                <Button
                    className={'w-[200px]'}
                    title={'Submit'}
                    loading={isCreating || isUpdating}
                    onClick={onSubmit}
                />
            </div>
        </div>
    )
}
